import { Api } from '@/core/api.js'
const api = new Api()

// initial state
const state = {
  locations: [],
  selected: {},
  regions: [],
  provinces: [],
  types: [],
  restaurant: false,
  province: [],
  enviroment: [],
  cluster: [],
  all_competence: {},
  competence: {},
  sales: [],
  consume: [],
  dafoOptions: [],
  dafoData: [],
  competenceData: { 1: false, 2: false, 3: false, 4: false, 5: false },
  comparation: {},
  moments: {},
  pmix: {},
  objectives: {},
  marketing: {},
  strategies: {},
  national_actions: {},
  channelData: [],
  service: [],
  serviceData: [],
  diagnosticDescriptions: {},
  menu: []
}

// getters
const getters = {
  getLocations: (state, getters, rootState) => {
    return state.locations
  },

  getProvinces: (state, getters, rootState) => {
    return state.provinces
  },

  getProvince: (state, getters, rootState) => {
    return state.province
  },

  getDiagnosticDescriptions: (state, getters, rootState) => {
    return state.diagnosticDescriptions
  },

  getSelectedLocation: (state, getters, rootState) => {
    return state.selected
  },

  getRegions: (state, getters, rootState) => {
    return state.regions
  },

  getTypes: (state, getters, rootState) => {
    return state.types
  },

  getRestaurantSelected: (state, getters, rootState) => {
    return state.restaurant
  },

  getEnviroment: (state, getters, rootState) => {
    return state.enviroment
  },

  getCluster: (state, getters, rootState) => {
    return state.cluster
  },

  getCompetence: (state, getters, rootState) => {
    return state.competence
  },

  getAllCompetence: (state, getters, rootState) => {
    return state.all_competence
  },

  getSales: (state, getters, rootState) => {
    return state.sales
  },

  getConsume: (state, getters, rootState) => {
    return state.consume
  },

  getDafoOptions: (state, getters, rootState) => {
    return state.dafoOptions
  },

  getDafoData: (state, getters, rootState) => {
    return state.dafoData
  },

  getCompetenceData: (state, getters, rootState) => {
    return state.competenceData
  },

  getComparation: (state, getters, rootState) => {
    return state.comparation
  },

  getMomentsOfDay: (state, getters, rootState) => {
    return state.moments
  },

  getPmix: (state, getters, rootState) => {
    return state.pmix
  },

  getObjectives: (state, getters, rootState) => {
    return state.objectives
  },

  getMarketing: (state, getters, rootState) => {
    return state.marketing
  },

  getStrategies: (state, getters, rootState) => {
    return state.strategies
  },

  getNationalActions: (state, getters, rootState) => {
    return state.national_actions
  },

  getChannelData: (state, getters, rootState) => {
    return state.channelData
  },

  getService: (state, getters, rootState) => {
    return state.service
  },

  getServiceData: (state, getters, rootState) => {
    return state.serviceData
  },

  getMenu: (state, getters, rootState) => {
    return state.menu
  }
}

// actions
const actions = {
  loadRegions ({ commit }) {
    var response = [
      { id: -1, name: 'Sin región' },
      { id: 1, name: 'Este' },
      { id: 2, name: 'Levante' },
      { id: 3, name: 'Centro' },
      { id: 4, name: 'Sur' },
      { id: 5, name: 'McOpCo' },
      { id: 6, name: 'McOpCo' }

    ]

    // TODO API REQUEST
    commit('setRegions', response)
  },

  loadTypes ({ commit }) {
    var response = [
      { id: 1, name: 'In-Store' },
      { id: 2, name: 'Mall' },
      { id: 3, name: 'Free Service' }
    ]

    // TODO API REQUEST
    commit('setTypes', response)
  },

  loadProvince ({ commit }, iRestaurant) {
    return api
      .post('restaurant/province', { id: iRestaurant })
      .then(function (response) {
        if (response.status) {
          return commit('setProvince', response.data)
        }
      })
  },

  loadDiagnosticDescriptions ({ commit }, iRestaurant) {
    return api.post('diagnostic/descriptions', {}).then(function (response) {
      if (response.status) {
        commit('setDiagnosticDescriptions', response.data)
        return response.data
      }
    })
  },

  loadEnviroment ({ commit }, iRestaurant) {
    return api
      .post('restaurant/enviroment', { id: iRestaurant })
      .then(function (response) {
        if (response.status) {
          return commit('setEnviroment', response.data)
        }
      })
  },

  loadCluster: ({ commit, dispatch }, iRestaurant) => {
    return api
      .post('restaurant/cluster', { restaurant_id: iRestaurant })
      .then(function (response) {
        if (response.status) {
          if (response.data.week == null) {
            // response.data.week = {"trabajadores":{"week":"","weekend":"","daypart":""},"estudiantes":{"week":"","weekend":"","daypart":""},"familias":{"week":"","weekend":"","daypart":""},"pareja":{"week":"","weekend":"","daypart":""},"grupos":{"week":"","weekend":"","daypart":""},"individual":{"week":"","weekend":"","daypart":""}}
            return commit('setCluster', response.data)
          } else {
            return commit('setCluster', response.data)
          }
        }
      })
  },

  loadAllCompetence: ({ commit, dispatch }, iRestaurant) => {
    return api
      .post('competence', { restaurant_id: iRestaurant })
      .then(function (response) {
        if (response.status) {
          if (!response.data.hasOwnProperty('0')) {
            response.data[0] = {}
          }
          return commit('setAllCompetence', response.data)
        }
      })
  },

  loadCompetence: ({ commit, dispatch }, iRestaurant) => {
    return api
      .post('restaurant/competence', { restaurant_id: iRestaurant })
      .then(function (response) {
        if (response.status) {
          return commit('setCompetence', response.data)
        }
      })
  },

  loadSales: ({ commit, dispatch }, iRestaurant) => {
    return api
      .post('restaurant/sales', { id: iRestaurant })
      .then(function (response) {
        if (response.status) {
          return commit('setSales', response.data)
        }
      })
  },

  loadConsume: ({ commit, dispatch }, iRestaurant) => {
    return api
      .post('restaurant/consume', { id: iRestaurant })
      .then(function (response) {
        if (response.status) {
          return commit('setConsume', response.data)
        }
      })
  },

  loadDafoOptions: ({ commit, dispatch }, iRestaurant) => {
    return api
      .post('restaurant/dafo', { id: iRestaurant })
      .then(function (response) {
        if (response.status) {
          return commit('setDafoOptions', response.data)
        }
      })
  },

  loadDafoData: ({ commit, dispatch }, iRestaurant) => {
    return api
      .post('restaurant/dafo/data', { id: iRestaurant })
      .then(function (response) {
        if (response.status) {
          return commit('setDafoData', response.data)
        }
      })
  },

  loadCompetenceData: ({ commit, dispatch }, iRestaurant) => {
    return api
      .post('restaurant/competence/data', { restaurant_id: iRestaurant })
      .then(function (response) {
        if (response.status) {
          if (response.data) {
            return commit('setCompetenceData', response.data)
          }

          return false
        }
      })
  },

  loadComparation: ({ commit, dispatch }, iRestaurant) => {
    return api
      .post('restaurant/comparation', { restaurant_id: iRestaurant })
      .then(function (response) {
        if (response.status) {
          return commit(
            'setComparation',
            response.data
              ? response.data
              : {
                service: '',
                relation: '',
                innovation: '',
                ambient: '',
                promotion: ''
              }
          )
        }
      })
  },

  loadMomentsOfDay: ({ commit }, iRestaurant) => {
    return api
      .get('restaurant/moments/' + iRestaurant)
      .then(function (response) {
        if (response.status) {
          return commit('setMomentsOfDay', response.data)
        }
      })
  },

  loadPmix: ({ commit }, iRestaurant) => {
    return api.get('restaurant/pmix/' + iRestaurant).then(function (response) {
      if (response.status) {
        return commit('setPmix', response.data)
      }
    })
  },

  loadObjectives: ({ commit }, year) => {
    return api
      .post('restaurant/objectives', { year: year })
      .then(function (response) {
        if (response.status) {
          return commit('setObjectives', response.data)
        }
      })
  },

  loadMarketing: ({ commit, dispatch }, aData) => {
    return api
      .post('restaurant/marketing', {
        restaurant_id: aData.restaurant_id,
        year: aData.year
      })
      .then(function (response) {
        if (response.status) {
          return commit('setMarketing', response.data)
        }
      })
  },

  loadStrategies: ({ commit }, year) => {
    return api
      .post('restaurant/strategies', { year: year })
      .then(function (response) {
        if (response.status) {
          response.data.unshift('')
          return commit('setStrategies', response.data)
        }
      })
  },

  loadNationalActions: ({ commit }, year) => {
    return api.get('restaurant/actions/' + year).then(function (response) {
      if (response.status) {
        return commit('setNationalActions', response.data)
      }
    })
  },

  loadChannelData: ({ commit }, id) => {
    return api.get('restaurant/channel/data/' + id).then(function (response) {
      if (response.status) {
        return commit('setChannelData', response.data)
      }
    })
  },

  loadService: ({ commit }) => {
    return api.get('restaurant/service/').then(function (response) {
      if (response.status) {
        return commit('setService', response.data)
      }
    })
  },

  loadServiceData: ({ commit }, id) => {
    return api.get('restaurant/service/data/' + id).then(function (response) {
      if (response.status) {
        return commit('setServiceData', response.data)
      }
    })
  },

  addEnviroment: ({ commit, dispatch }, aData) => {
    return api.post('restaurant/enviroment/add', {
      name: aData.name,
      id: aData.id
    })
  },

  selectEnviroment: ({ commit, dispatch }, aData) => {
    return api.post('restaurant/enviroment/select', {
      id: aData.id,
      restaurant_id: aData.restaurant_id
    })
  },

  unselectEnviroment: ({ commit, dispatch }, aData) => {
    return api.post('restaurant/enviroment/unselect', {
      id: aData.id,
      restaurant_id: aData.restaurant_id
    })
  },

  deleteEnviroment: ({ commit, dispatch }, aData) => {
    return api.post('restaurant/enviroment/delete', { id: aData.id })
  },

  updateCluster: ({ commit, dispatch }, aData) => {
    return api.post('restaurant/cluster/update', {
      restaurant_id: aData.restaurant_id,
      data: JSON.stringify(aData.data)
    })
  },

  updateDafo: ({ commit, dispatch }, aData) => {
    return api.post('restaurant/dafo/update', {
      restaurant_id: aData.restaurant_id,
      dafo: aData.dafo
    })
  },

  updateCompetenceData: ({ commit, dispatch }, aData) => {
    return api.post('restaurant/competence/update', {
      restaurant_id: aData.restaurant_id,
      competence: aData.competence,
      intensity: aData.intensity
    })
  },

  addBrand: ({ commit, dispatch }, aData) => {
    return api.post('restaurant/competence/add', {
      name: aData.name,
      type: aData.type,
      restaurant_id: aData.restaurant_id
    })
  },

  updateComparation: ({ commit, dispatch }, aData) => {
    return api.post('restaurant/comparation/update', {
      restaurant_id: aData.restaurant_id,
      mcd: JSON.stringify(aData.mcd),
      rest1: JSON.stringify(aData.rest1),
      rest2: JSON.stringify(aData.rest2),
      rest3: JSON.stringify(aData.rest3)
    })
  },

  updateObjectives: ({ commit, dispatch }, aData) => {
    return api.post('restaurant/objectives/update', {
      restaurant_id: aData.restaurant_id,
      tableData: aData.tableData,
      year: aData.year
    })
  },

  updateMarketingPhoto: ({ commit, dispatch }, aData) => {
    var formData = new FormData()
    formData.append('file', aData.file)

    return api
      .upload('restaurant/marketing/update', formData)
      .then(function (response) {
        return response
      })
  },
  
  uploadRRSS({ commit }, data) {
    const formData = new FormData();
    formData.append("file", data.file);

    return api
      .upload('restaurant/rrss/update', formData)
      .then(function (response) {
        return response
      })
  },

  updateDiagnosticSection: ({ commit, dispatch }, aData) => {
    var formData = new FormData()
    formData.append('section', aData.section)
    formData.append('file', aData.file)

    return api
      .upload('diagnostic/descriptions/update', formData)
      .then(function (response) {
        return response
      })
  },

  updateStrategies: ({ commit, dispatch }, aData) => {
    return api.post('restaurant/strategies/update', {
      restaurant_id: aData.restaurant_id,
      tableData: aData.tableData,
      year: aData.year
    })
  },

  addAction: ({ commit, dispatch }, aData) => {
    return api.post('restaurant/action/add', {
      restaurant_id: aData.restaurant_id,
      data: aData.Data,
      year: aData.year
    })
  },

  updateAction: ({ commit, dispatch }, aData) => {
    return api.post('restaurant/action/update', { data: aData.Data })
  },

  deleteAction: ({ commit, dispatch }, id) => {
    return api.post('restaurant/action/delete', { id: id })
  },

  updateChannelData: ({ commit, dispatch }, aData) => {
    return api.post('restaurant/channel/update', {
      restaurant_id: aData.restaurant_id,
      restaurant_name: aData.restaurant_name,
      restaurant_site: aData.restaurant_site,
      address: aData.address,
      CIF: aData.CIF,
      fiscal_address: aData.fiscal_address,
      phone: aData.phone,
      opening_date: aData.opening,
      channel: JSON.stringify(aData.channel),
      email: aData.email,
      razon: aData.razon,
      region: aData.region,
      service: JSON.stringify(aData.service),
      channel_plan: JSON.stringify(aData.channel_plan),
      channel_plan_date: aData.channel_plan_date,
      mop_schedule: JSON.stringify(aData.mop_schedule)
    })
  },

  pushFavLocation ({ commit }, location) {
    return api
      .post('user/favorite', { restaurant_id: location.id })
      .then(function (response) {
        if (response.status) {
          return true
        }
      })
  },

  uploadRestaurant: ({ commit, dispatch }, restaurant) => {
    var path = restaurant.id == -1 ? 'add' : restaurant.id + '/update'
    return api.post('restaurant/' + path, restaurant).then(function (data) {
      if (data.status) {
        data.data.available = true
        return commit('addLocation', data.data)
      }
    })
  },

  removeBrand: ({ commit, dispatch }, id) => {
    return api.get('restaurant/competence/remove/' + id).then(function (data) {
      if (data.status) {
        return commit('removeCompetence', id)
      }
    })
  },

  removeRestaurant: ({ commit, dispatch }, id) => {
    return api.get('restaurant/' + id + '/delete').then(function (data) {
      if (data.status) {
        return commit('removeLocation', id)
      }
    })
  },

  loadMenu: ({ commit }) => {
    return api.get('restaurant/getMenu').then(function (data) {
      if (data.status) {
        return commit('setMenu', data.data)
      }
    })
  },

  getRestaurantLog: ({ commit }, restaurant_id) => {
    return api.get('restaurant/log/' + restaurant_id).then(function (data) {
      if (data.status) {
        return data.data
      }
    })
  }
}

// mutations
const mutations = {
  setLocations (state, locations) {
    state.locations = locations
  },

  setProvince (state, province) {
    state.province = province
  },

  setDiagnosticDescriptions (state, diagnostic_descriptions) {
    state.diagnosticDescriptions = diagnostic_descriptions
  },

  setEnviroment (state, enviroment) {
    state.enviroment = { ...enviroment }
  },

  setCluster (state, cluster) {
    state.cluster = cluster
  },

  setCompetence (state, competence) {
    state.competence = competence
  },

  setAllCompetence (state, competence) {
    state.all_competence = competence
  },

  setSales (state, sales) {
    state.sales = sales
  },

  setConsume (state, consume) {
    state.consume = consume
  },

  setDafoOptions (state, dafoOptions) {
    state.dafoOptions = dafoOptions
  },

  setDafoData (state, dafoData) {
    state.dafoData = dafoData
  },

  setCompetenceData (state, competenceData) {
    state.competenceData = competenceData
  },

  setComparation (state, comparation) {
    state.comparation = comparation
  },

  setMomentsOfDay (state, moments) {
    state.moments = moments
  },

  setPmix (state, pmix) {
    state.pmix = pmix
  },

  setObjectives (state, objectives) {
    state.objectives = objectives
  },

  setMarketing (state, marketing) {
    state.marketing = marketing
  },

  setStrategies (state, strategies) {
    state.strategies = strategies
  },
  setNationalActions (state, national_actions) {
    state.national_actions = national_actions
  },

  setRegions (state, regions) {
    state.regions = regions
  },

  setTypes (state, types) {
    state.types = types
  },

  setChannelData (state, channelData) {
    state.channelData = channelData
  },

  setService (state, service) {
    state.service = service
  },

  setServiceData (state, serviceData) {
    state.serviceData = serviceData
  },

  setSelectedLocation (state, location) {
    for (var key in state.locations) {
      state.locations[key].selected = false
    }
    location.selected = true
    state.selected = location
    localStorage.site = location.site
  },

  setSelectedRestaurant (state, restaurant) {
    state.restaurant = restaurant
  },

  setSelectedRestaurantByID (state, id) {
    state.restaurant = state.locations[id]
  },

  addLocation (state, location) {
    var locations = { ...state.locations }
    locations[location.id] = location

    state.locations = locations
  },

  removeCompetence (state, id) {
    var competence = { ...state.competence }
    delete competence[id]

    state.competence = competence
  },

  removeLocation (state, id) {
    var locations = { ...state.locations }
    delete locations[id]

    state.locations = locations
  },

  setMenu (state, menu) {
    state.menu = menu
  },

  setMenuItemSelected(state, { itemId, selected }) {
    const menu = state.menu;

    if (menu.admin) {
      const market = menu.admin.PT || menu.admin.ES;
      if (market) {
        market.menuFull.forEach(item => {
          item.selected = false;
        });
        market.menuReduced.forEach(item => {
          item.selected = false;
        });
        
        if (selected) {
          const item = market.menuFull.find(item => item.url === itemId) || 
                      market.menuReduced.find(item => item.url === itemId);
          if (item) {
            item.selected = true;
          }
        }
      }
    } 
    else {
      Object.values(menu).forEach(items => {
        if (Array.isArray(items)) {
          items.forEach(item => {
            item.selected = false;
          });
        }
      });
      
      if (selected) {
        Object.values(menu).forEach(items => {
          if (Array.isArray(items)) {
            const item = items.find(item => item.url === itemId);
            if (item) {
              item.selected = true;
            }
          }
        });
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
